<template>
  <div class="crew-plant-table-wrap">
    <table class="table table-sm worker-table mb-0">
      <thead>
        <tr>
          <th class="small">Date</th>
          <th class="small">Plant</th>
          <th class="small text-center">Qty</th>
          <th v-if="showCost" class="small text-center">Rate</th>
          <th v-if="showCost" class="small text-center">Claim</th>
          <th v-if="editable" class="small text-center"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(pe, i) in sortedEntries" :key="pe.id || `new-${i}`">
          <td class="small align-middle">{{ formatDate(pe.date) }}</td>
          <td class="small align-middle">
            {{ pe.plant_name }}
            <span v-if="pe.plant_id_rego" class="crew-plant-rego"
              >({{ pe.plant_id_rego }})</span
            >
            <b-badge
              v-if="pe.is_amended"
              variant="warning"
              pill
              class="ml-1 plant-amended-badge"
            >
              Amended ×{{ pe.amendment_count }}
            </b-badge>
          </td>
          <td class="small text-center align-middle">
            {{ plantEntryQtyLabel(pe) }}
          </td>
          <td v-if="showCost" class="small text-center align-middle">
            <template v-if="pe.rate_snapshot != null">
              ${{ formatCurrency(pe.rate_snapshot)
              }}{{ pe.rate_type_snapshot === 'hourly' ? '/hr' : '/day' }}
            </template>
            <span v-else class="text-muted">pending save</span>
          </td>
          <td
            v-if="showCost"
            class="small text-center align-middle font-weight-bold"
          >
            {{
              pe.claim_value != null
                ? `$${formatCurrency(pe.claim_value)}`
                : '-'
            }}
          </td>
          <td v-if="editable" class="small text-center align-middle">
            <button
              type="button"
              class="crew-plant-remove"
              aria-label="Remove"
              @click="$emit('remove', pe)"
            >
              &times;
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatCurrency, plantEntryQtyLabel } from '@/utils/timesheetHelpers'

export default {
  name: 'SupervisorCrewPlantPanel',

  props: {
    entries: { type: Array, default: () => [] },
    editable: { type: Boolean, default: false },
    // BA reviewers see the $ rate/claim columns; supervisors viewing their
    // own submission must never see dollar rates (see PlantEquipmentController
    // ::mine() on the API — the same rule applied there).
    showCost: { type: Boolean, default: true },
  },

  computed: {
    // Sorts a copy. Sorting `this.entries` in place would reorder the very
    // array the parent holds on ts.plant_entries — a silent prop mutation.
    sortedEntries() {
      return (this.entries || []).slice().sort((a, b) => {
        if (a.date !== b.date) return (a.date || '') < (b.date || '') ? -1 : 1
        return (a.plant_name || '') < (b.plant_name || '') ? -1 : 1
      })
    },
  },

  methods: {
    formatCurrency,
    plantEntryQtyLabel,

    // The T00:00:00 suffix is required: `new Date('2026-08-13')` is parsed as
    // UTC and renders as the previous day in Australia/Perth.
    formatDate(date) {
      if (!date) return '-'
      return new Date(date + 'T00:00:00').toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/layouts/timesheet-shared';
@import '~@/assets/scss/layouts/supervisor-worker-shared';

.crew-plant-remove {
  border: 0;
  background: transparent;
  color: #adb5bd;
  font-size: 16px;
  line-height: 1;
  width: 24px;
  height: 24px;
  border-radius: 4px;

  &:hover {
    color: #dc3545;
    background: #fdecee;
  }
}
</style>
